export function getInitials(name: string): string {
  const [firstWord = '', secondWord = ''] = name.split(' ')
  const firstLetter = firstWord.charAt(0)
  const secondLetter = secondWord.charAt(0)
  return `${firstLetter.toUpperCase()}${secondLetter.toUpperCase()}`
}
